export default __webpack_public_path__ + "static/media/hogwarts-1.6291d00d.jpg";